<template>
    <BasePage>

        <template v-slot:menu>
            <SiteLogo />
        </template>

        <template v-slot:page-body>
            <router-view />
        </template>

    </BasePage>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import BasePage from './BasePage.vue'
import SiteLogo from '@/layout/SiteLogo.vue'

    export default defineComponent({
        components: {
            BasePage,
            SiteLogo
        },
    })
</script>

